import { render } from "./HeavyMachine.vue?vue&type=template&id=ccbe1ef4&scoped=true"
import script from "./HeavyMachine.vue?vue&type=script&lang=js"
export * from "./HeavyMachine.vue?vue&type=script&lang=js"

import "./HeavyMachine.vue?vue&type=style&index=0&id=ccbe1ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbe1ef4"]])

export default __exports__